<div *ngIf="calendarData"
    class="calendar calendar-main"
    role="region"
    (keydown)="onCalendarKeydown($event)"
    attr.aria-label="{{labels.calendarName}}, {{calendarObject.selectedMonth}} {{calendarObject.selectedYear}}">
    <div class="calendar-header" [ngClass]="{'month-only': !allowNavigation}">
        <a class="arrow-prev header-cell"
            *ngIf="calendarObject.isPreviousMonthEnabled(); else prevMonthDisabled"
            (click)="calendarObject.previousMonth()"
            (keydown.enter)="calendarObject.previousMonth()"
            (keyup.esc)="close($event)"
            tabindex="-1"
            >
            <finder-font-icon name="previous" size="s" attr.aria-label="{{labels.previousMonth}}" role="button"></finder-font-icon>
        </a>
        <ng-template #prevMonthDisabled>
            <span class="arrow-prev disabled">
                <finder-font-icon name="previous" size="s" attr.aria-label="{{labels.previousMonth}}, {{labels.disabled}}" aria-disabled="true" role="button">
                </finder-font-icon>
            </span>
        </ng-template>
        <div id="calendar-title" class="month-and-year header-cell">
            <span class="month-name">{{calendarObject.selectedMonth}}</span>
            <ng-container *ngIf="displayYear">{{calendarObject.selectedYear}}</ng-container>
        </div>
        <a class="arrow-next header-cell"
            *ngIf="calendarObject.isNextMonthEnabled(); else nextMonthDisabled"
            (click)="calendarObject.nextMonth()"
            (keydown.enter)="calendarObject.nextMonth()"
            (keyup.esc)="close($event)"
            (keydown.tab)="tabAction($event)"
            tabindex="-1"
            >
            <finder-font-icon name="next" size="s" attr.aria-label="{{labels.nextMonth}}" role="button"></finder-font-icon>
        </a>
        <!-- place holder accepts content from a single source -->
        <ng-content select="[calendar-link]"></ng-content>
        <ng-template #nextMonthDisabled>
            <span class="arrow-next disabled">
                <finder-font-icon name="next" size="s" attr.aria-label="{{labels.nextMonth}}, {{labels.disabled}}" aria-disabled="true" role="button">
                </finder-font-icon>
            </span>
        </ng-template>
    </div>
    <div class="calendar-content">
        <table class="calendar-table">
            <thead class="table-header">
                <tr class="calendar-row weekdays" tabindex="0">
                    <th *ngFor="let day of calendarObject.weekDays; index as i"
                        class="calendar-cell" attr.aria-label="{{calendarObject.fullNameWeekDays[i]}}"
                        aria-hidden="true"
                        tabindex="-1">
                        {{day}}
                    </th>
                </tr>
            </thead>
            <tbody class="table-body">
                <tr class="calendar-row {{!week ? 'empty' : ''}}" *ngFor="let week of calendarData; let row = index">
                    <td *ngFor="let day of week; let column = index"
                        class="calendar-cell date-{{calendarObject | getSimpleDate: day}}"
                        [ngClass]="{'selected': isDaySelected(day, row, column), 'highlighted': isHighlightedDate(day)}">
                        <!-- Check to see if we have a tooltip for the day. Store the result to use later -->
                        <ng-container *ngIf="calendarObject | getDayInData: dayData: day: 'toolTip'; else anchor; let toolTip">
                            <finder-tooltip [tooltip]="toolTip" [title]="calendarObject | getSimpleDate: day" [id]="day">
                                <ng-container *ngTemplateOutlet="anchor"></ng-container>
                            </finder-tooltip>
                        </ng-container>
                        <ng-template #anchor>
                            <a *ngIf="calendarObject.isDateEnabled(day); else dayDisabled"
                                (click)="selectDate(day, $event)"
                                (keydown)="onKeydown({day: day, row: row, column: column, isLastDay: day === calendarObject.currentDaysInMonth}, $event)"
                                [ngClass]="{'last-day': day === calendarObject.currentDaysInMonth, 'first-day': day === 1}"
                                class="cell-{{row + '-' + column}}"
                                role="button"
                                tabindex="0"
                                [attr.data-date]="calendarObject | getSimpleDate: day"
                                [attr.aria-label]="getCellDayText(day, column, isDaySelected(day, row, column))">
                                {{day}}
                            </a>
                        </ng-template>
                        <ng-template #dayDisabled>
                            <span class="old-day" attr.aria-label="{{day}}, {{labels.disabled}}" role="button">{{day}}</span>
                        </ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
